import { render, staticRenderFns } from "./DocumentCopy.vue?vue&type=template&id=558fba5c&scoped=true"
import script from "./DocumentCopy.vue?vue&type=script&lang=js"
export * from "./DocumentCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558fba5c",
  null
  
)

export default component.exports